module["exports"] = [
  "Phd."
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/cz/name/suffix.js
// module id = 237
// module chunks = 0